import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "hint"]
  static values = {
    minLength: { type: Number, default: 3 },
    errorRequired: String,
    errorTooShort: String,
    successSuffix: String,
    signupPath: String
  }

  sanitize() {
    const cleaned = this.inputTarget.value.toLowerCase().replace(/[^a-z0-9_\-]/g, "")
    if (cleaned !== this.inputTarget.value) this.inputTarget.value = cleaned
    this.hintTarget.removeAttribute("data-state")
    this.hintTarget.textContent = cleaned.length > 0 ? `gimmo.me/${cleaned}` : ""
  }

  submit(event) {
    event.preventDefault()
    const value = this.inputTarget.value.trim()

    if (!value) {
      this.#setHint("error", this.errorRequiredValue)
      this.inputTarget.focus()
      return
    }

    if (value.length < this.minLengthValue) {
      this.#setHint("error", this.errorTooShortValue)
      return
    }

    this.#setHint("success", `✓ gimmo.me/${value} ${this.successSuffixValue}`)

    const url = new URL(this.signupPathValue, window.location.origin)
    url.searchParams.set("username", value)
    window.location.href = url.toString()
  }

  #setHint(state, text) {
    this.hintTarget.dataset.state = state
    this.hintTarget.textContent = text
  }
}
